import { EffectComposer, Vignette } from "@react-three/postprocessing"
import Orchestreur from "../../Orchestreur"
import EnvMap from "../../props/EnvMap"
import ActeOneModels from "../One/models/ActeOneModels"
import CameraOne from "../One/props/camera"
import LightOne from "../One/props/lights"
import ActeTwoModels from "./models/ActeTwoModels"
import CameraTwo from "./props/camera"


export default function ActeTwo({ progress }) {
    return (
        <>  
            <Orchestreur
                id={1}
                progress={progress}
                range={{ start: 0.35, end: 0.6 }}
                Env={EnvMap}
                Lights={LightOne}
                Models={ActeTwoModels}
                Camera={CameraTwo}
            />
        </>
    )
}